import '../../components/SeoReport/ReportCard.less';
import '../../components/SeoReport/ReportElement.less';
import './AuditReport.less';
import React, { useMemo, useEffect } from 'react';
import { SeoAudit, SeoAuditStructure } from './types';
import AuditReportSummary from './AuditReportSummary';
import AuditReportSidebar from './AuditReportSidebar';
import AuditReportCategories from './AuditReportCategories';
import { extractSeoAuditData } from './utils';

type Props = {
    seoAudit: SeoAudit;
    seoAuditStructure: SeoAuditStructure;
};

export default function AuditReport({ seoAudit, seoAuditStructure }: Props) {
    const { sections, createdAt, url, overview, categorizedSections, categorizedSectionsCounts, auditImportantFixes, categoriesScores } = useMemo(
        () => extractSeoAuditData(seoAudit, seoAuditStructure),
        [seoAudit, seoAuditStructure]
    );

    useEffect(() => {
        let currentLocation = window.location.href;
        const hasInternalAnchor = currentLocation.includes('#');
        if (hasInternalAnchor) {
            const seoTestKey = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`;
            const seoTestElement = document.getElementById(seoTestKey);
            if (seoTestElement) {
                seoTestElement.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }
    }, []);

    return (
        <div
            data-cy="analysis-report"
            className="report-wrapper"
        >
            <div className="report-summary deep-analysis">
                <AuditReportSummary
                    id="header-seo-summary"
                    url={url}
                    createdAt={createdAt}
                    scoreData={overview}
                    importantFixes={auditImportantFixes}
                />

                <AuditReportCategories
                    url={url}
                    sections={sections}
                    categorizedSections={categorizedSections}
                    categorizedSectionsCounts={categorizedSectionsCounts}
                    categoriesScores={categoriesScores}
                />

                {Object.keys(seoAudit.sections).length >= 5 && (
                    <AuditReportSummary
                        id="footer-seo-summary"
                        url={url}
                        createdAt={createdAt}
                        scoreData={overview}
                        importantFixes={auditImportantFixes}
                    />
                )}
            </div>

            <AuditReportSidebar
                generalScoreData={overview}
                sections={sections}
                categorizedSections={categorizedSections}
                categorizedSectionsCounts={categorizedSectionsCounts}
            />
        </div>
    );
}
